// @ts-ignore
import type * as SchemaTypes from '../../../../../graphql/api/index';

import { gql } from 'graphql-tag';
import { BlockFragmentDoc } from '../../../CmsBlock.fragment.generated';
import { QuestionnaireConditionFragmentDoc } from '../condition/QuestionnaireCondition.fragment.generated';
export const QuestionnaireStepContentContentFragmentDoc = gql`
    fragment questionnaireStepContentContent on QuestionnaireStepContentContent {
  __typename
  blocks {
    ...block
  }
  conditions {
    ...questionnaireCondition
  }
}
    ${BlockFragmentDoc}
${QuestionnaireConditionFragmentDoc}`;